/**
 * 관리자 ③ 공급-수요 맵
 * ($j.Pages.Admin.SupplyDemand / body data-page-name="SupplyDemand")
 *
 * 시도 × 장비종류 그리드. 회원당발주(=공급/수요)로 구조적 회원과잉(이탈위험) 지역 식별.
 */
export default class SupplyDemand {
    initialize() {
        $('#sdRefresh').on('click', () => this._load(true));
        this._load();
    }

    async _load(nocache = false) {
        try {
            const res = await $.ajax({
                url: '/adm/ajax/stat/supply-demand/data', type: 'get',
                data: nocache ? { nocache: 1 } : {}
            });
            if (!res.ok) return;
            this._renderEquip(res.equipment);
            this._renderGrid(res.grid);
            if (res.cached_at) $('#sdCachedAt').text(`집계시각 ${res.cached_at} · 최근 ${res.days}일 발주`);
        } catch (e) {
            console.error('공급-수요 로드 실패', e);
        }
    }

    _renderEquip(equip) {
        const html = equip.map(e => {
            const warn = e.demand === 0 && e.supply > 0
                ? `<div class="sub warn">유료회원 0 — 발주 ${this._c(e.supply)}건 미공략</div>`
                : `<div class="sub">공급/수요 ${e.demand > 0 ? (e.supply / e.demand).toFixed(2) : '-'}</div>`;
            return `<div class="card"><div class="card-body">
                <div class="sub">${e.car_type}</div>
                <div class="big">${this._c(e.demand)}<span class="sub"> 회원</span> / ${this._c(e.supply)}<span class="sub"> 발주</span></div>
                ${warn}
            </div></div>`;
        }).join('');
        $('#sdEquip').html(html);
    }

    _renderGrid(grid) {
        // 피벗: 행=시도, 열=장비(수요 있는 것만)
        const sidos = [...new Set(grid.map(c => c.sido))];
        const types = [...new Set(grid.map(c => c.car_type))];
        const map = {};
        grid.forEach(c => { map[`${c.sido}|${c.car_type}`] = c; });

        let html = '<thead><tr><th>시도</th>' + types.map(t => `<th>${t}</th>`).join('') + '</tr></thead><tbody>';
        sidos.forEach(sido => {
            html += `<tr><td class="sido">${sido}</td>`;
            types.forEach(t => {
                const c = map[`${sido}|${t}`];
                if (!c) { html += '<td class="sd-na">-</td>'; return; }
                const cls = this._colorClass(c.ratio);
                html += `<td class="sd-cell ${cls}">
                    <div class="r">${c.ratio == null ? '-' : c.ratio}</div>
                    <div class="ds">${this._c(c.demand)} / ${this._c(c.supply)}</div>
                </td>`;
            });
            html += '</tr>';
        });
        html += '</tbody>';
        $('#sdGrid').html(html);
    }

    _colorClass(ratio) {
        if (ratio == null) return 'sd-na';
        if (ratio < 1) return 'sd-red';
        if (ratio < 2) return 'sd-orange';
        return 'sd-green';
    }

    _c(n) { return Number(n || 0).toLocaleString(); }

    destroy() {}
}
